const namespaceLoaders = {
  ru: {
    account_transfer: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/account_transfer.yml'),
    accounts_marketplace: () =>
      import(
        /* webpackChunkName: "i18n-ru-marketplace" */ 'i18n/adsimple/ru/accounts_marketplace.yml'
      ),
    advertisers: () =>
      import(/* webpackChunkName: "i18n-ru-advertisers" */ 'i18n/adsimple/ru/advertisers.yml'),
    agency: () => import(/* webpackChunkName: "i18n-ru-agency" */ 'i18n/adsimple/ru/agency.yml'),
    audits: () =>
      import(/* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/adsimple/ru/audits.yml'),
    auth: () => import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/adsimple/ru/auth.yml'),
    autoreplenish: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/autoreplenish.yml'),
    banners: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/banners.yml'),
    bank_cards: () => import(/* webpackChunkName: "i18n-ru-bank-cards" */ 'i18n/getuniq/ru/bank_cards.yml'),
    benchmarks: () =>
      import(/* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/adsimple/ru/benchmarks.yml'),
    billing: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/billing.yml'),
    campaigns_editor: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/campaigns_editor.yml'),
    common: () => import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/adsimple/ru/common.yml'),
    cookie_banner: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/adsimple/ru/cookie-banner.yml'),
    countries: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/countries.yml'),
    faq: () => import(/* webpackChunkName: "i18n-ru-faq" */ 'i18n/adsimple/ru/faq.yml'),
    finance: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/finance.yml'),
    form_errors: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/adsimple/ru/form_errors.yml'),
    industries: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/industries.yml'),
    invoices: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/invoices.yml'),
    marketplace: () =>
      import(/* webpackChunkName: "i18n-ru-marketplace" */ 'i18n/adsimple/ru/marketplace.yml'),
    media_planner: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/media_planner.yml'),
    navigation: () =>
      import(/* webpackChunkName: "i18n-ru-navigation" */ 'i18n/adsimple/ru/navigation/index.js'),
    oauth: () => import(/* webpackChunkName: "i18n-ru-oauth" */ 'i18n/adsimple/ru/oauth.yml'),
    onboarding: () =>
      import(/* webpackChunkName: "i18n-ru-core" */ 'i18n/adsimple/ru/onboarding.yml'),
    partners_program: () =>
      import(/* webpackChunkName: "i18n-ru-partners" */ 'i18n/adsimple/ru/partners_program.yml'),
    payment_order: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/payment_order.yml'),
    payment_profiles: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/payment_profiles.yml'),
    promised_payment: () =>
      import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/promised_payment.yml'),
    pulse: () => import(/* webpackChunkName: "i18n-ru-statistics" */ 'i18n/adsimple/ru/pulse.yml'),
    recommendations: () =>
      import(
        /* webpackChunkName: "i18n-ru-recommendations" */ 'i18n/adsimple/ru/recommendations.yml'
      ),
    referral: () =>
      import(/* webpackChunkName: "i18n-ru-referral" */ 'i18n/adsimple/ru/referral.yml'),
    reward_calculator: () =>
      import(/* webpackChunkName: "i18n-ru-partners" */ 'i18n/adsimple/ru/reward_calculator.yml'),
    services: () =>
      import(/* webpackChunkName: "i18n-ru-services" */ 'i18n/adsimple/ru/services.yml'),
    statistics: () =>
      import(/* webpackChunkName: "i18n-ru-statistics" */ 'i18n/adsimple/ru/statistics.yml'),
    tickets: () => import(/* webpackChunkName: "i18n-ru-tickets" */ 'i18n/adsimple/ru/tickets.yml'),
    user: () => import(/* webpackChunkName: "i18n-ru-user" */ 'i18n/adsimple/ru/user.yml'),
    wallets: () => import(/* webpackChunkName: "i18n-ru-finance" */ 'i18n/adsimple/ru/wallets.yml'),
  },
  en: {
    account_transfer: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/account_transfer.yml'),
    accounts_marketplace: () =>
      import(
        /* webpackChunkName: "i18n-en-marketplace" */ 'i18n/adsimple/en/accounts_marketplace.yml'
      ),
    advertisers: () =>
      import(/* webpackChunkName: "i18n-en-advertisers" */ 'i18n/adsimple/en/advertisers.yml'),
    agency: () => import(/* webpackChunkName: "i18n-en-agency" */ 'i18n/adsimple/en/agency.yml'),
    audits: () =>
      import(/* webpackChunkName: "i18n-en-recommendations" */ 'i18n/adsimple/en/audits.yml'),
    auth: () => import(/* webpackChunkName: "i18n-en-core" */ 'i18n/adsimple/en/auth.yml'),
    autoreplenish: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/autoreplenish.yml'),
    banners: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/banners.yml'),
    bank_cards: () => import(/* webpackChunkName: "i18n-en-bank-cards" */ 'i18n/getuniq/en/bank_cards.yml'),
    benchmarks: () =>
      import(/* webpackChunkName: "i18n-en-recommendations" */ 'i18n/adsimple/en/benchmarks.yml'),
    billing: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/billing.yml'),
    campaigns_editor: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/campaigns_editor.yml'),
    common: () => import(/* webpackChunkName: "i18n-en-core" */ 'i18n/adsimple/en/common.yml'),
    cookie_banner: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/adsimple/en/cookie-banner.yml'),
    countries: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/countries.yml'),
    faq: () => import(/* webpackChunkName: "i18n-en-faq" */ 'i18n/adsimple/en/faq.yml'),
    finance: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/finance.yml'),
    form_errors: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/adsimple/en/form_errors.yml'),
    industries: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/industries.yml'),
    invoices: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/invoices.yml'),
    marketplace: () =>
      import(/* webpackChunkName: "i18n-en-marketplace" */ 'i18n/adsimple/en/marketplace.yml'),
    media_planner: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/media_planner.yml'),
    navigation: () =>
      import(/* webpackChunkName: "i18n-en-navigation" */ 'i18n/adsimple/en/navigation/index.js'),
    oauth: () => import(/* webpackChunkName: "i18n-en-oauth" */ 'i18n/adsimple/en/oauth.yml'),
    onboarding: () =>
      import(/* webpackChunkName: "i18n-en-core" */ 'i18n/adsimple/en/onboarding.yml'),
    partners_program: () =>
      import(/* webpackChunkName: "i18n-en-partners" */ 'i18n/adsimple/en/partners_program.yml'),
    payment_order: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/payment_order.yml'),
    payment_profiles: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/payment_profiles.yml'),
    promised_payment: () =>
      import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/promised_payment.yml'),
    pulse: () => import(/* webpackChunkName: "i18n-en-statistics" */ 'i18n/adsimple/en/pulse.yml'),
    recommendations: () =>
      import(
        /* webpackChunkName: "i18n-en-recommendations" */ 'i18n/adsimple/en/recommendations.yml'
      ),
    referral: () =>
      import(/* webpackChunkName: "i18n-en-referral" */ 'i18n/adsimple/en/referral.yml'),
    reward_calculator: () =>
      import(/* webpackChunkName: "i18n-en-partners" */ 'i18n/adsimple/en/reward_calculator.yml'),
    services: () =>
      import(/* webpackChunkName: "i18n-en-services" */ 'i18n/adsimple/en/services.yml'),
    statistics: () =>
      import(/* webpackChunkName: "i18n-en-statistics" */ 'i18n/adsimple/en/statistics.yml'),
    tickets: () => import(/* webpackChunkName: "i18n-en-tickets" */ 'i18n/adsimple/en/tickets.yml'),
    user: () => import(/* webpackChunkName: "i18n-en-user" */ 'i18n/adsimple/en/user.yml'),
    wallets: () => import(/* webpackChunkName: "i18n-en-finance" */ 'i18n/adsimple/en/wallets.yml'),
  },
}

export default namespaceLoaders
